import React, { useContext } from 'react'

import { Inline } from '@contentful/rich-text-types'
import { gnarSpec } from '../../../lib/tracking/gnar'
import { PageContext } from '../../../contexts/page-context'
import { PlacementContext } from '../../../contexts/placement-context'
import { ExternalLink, useLinkStyleFromTheme } from '../../ui-lib/link'

interface InlineLinkProps extends Inline {
  children?: React.ReactNode
}

export const InlineLink: React.FC<InlineLinkProps> = (props) => {
  const href: string = props.data.uri || ''

  const { pageId, slug } = useContext(PageContext)
  const { placement, placementInternalName } = useContext(PlacementContext)
  const linkStyle = useLinkStyleFromTheme()
  const isAnchorLink = href.startsWith('#')

  return (
    <ExternalLink
      onClick={() => {
        void gnarSpec.linkClick(pageId, slug, href, undefined, placement, placementInternalName)
      }}
      className={linkStyle}
      href={href}
      target={!isAnchorLink ? '_blank' : undefined}
    >
      {props.children}
    </ExternalLink>
  )
}
